import styled from "styled-components";
import RedirectIcon from "../../../images/RedirectIcon.svg";
import arrowdown from "../../../images/arrow-down.svg";
import arrowup from "../../../images/arrow-up.svg";
import PCCircledArrowUp from "../../../images/PC_circle_arrow_down.svg";
import StationsModalBg from "../../../images/StationsModalBg.png";

export const MenuWrapper = styled.div`
    z-index: ${({ pc }) => (pc == true ? "10" : "1")};
    cursor: pointer;
    margin:  ${({ station }) => (station ? "unset" : "24px 20px 0px auto")};
    position:relative;
    @media screen and (max-width: 850px){
        //display:${props => props.header ? "none" : ""};
        margin: 10px;
        
    }
`;

export const MenuItemWrapper = styled.div`
    border: 1px solid #fff;
    border-top-width: 0;
    padding-left: 0;
    display: grid;
    background-color: #000;
    position: fixed;
    right: 20px;
    margin-top: 5px;
    border: 1px solid white;
    border-radius: 5px;
    z-index:20;
    @media screen and (max-width: 750px){
        width:100%;
        right:0px;
    }
`

export const MenuItem = styled.li`
    color: #fff;
    list-style-type: none;
    padding: 11px 22px 10px 18px;
    border-bottom: 1px solid #3B3B3B;
`

export const Menu = styled.div`
    & img{
        width: 38px;
        height: 38px;
        color: #fff;
        border-radius: 5px;
    } 
`;

export const MenuModal = styled.div`
    z-index:10;
`;

export const Moredown = styled.img`
    position: absolute;
    top: 55px;
    right: 34px;
`;

export const MenuTab = styled.div`
    display: flex;
    flex-direction:${props => props.mobile == true || props.gift ? "" : "column"};
    flex: 30%;
    margin:2% auto 0;
    // width:95%;
    overflow-y: auto;
    
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        & {
            overflow:hidden;
        }
    } 
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        & {
            padding: 15px 0px 0px 0px;
        }
     }
    &::-webkit-scrollbar{
        height: 0px;
    }
    &::-webkit-scrollbar-track {
        background: #fff; 
    }
    &::-webkit-scrollbar-thumb{
        border-radius: 8px;
        background: #C1C1C1; 
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #C1C1C1; 
    }
    {
      -ms-overflow-style: none;
      scrollbar-width: thin;
    }
    @media screen and (max-width: 740px){
        padding: 15px 0px 0px;
        padding-top:${props => props?.showNotification === true ? "85px" : "0px"};
    }
    @media only screen and (min-width:1200px) and (max-width:1920px) {
        ${props => props.leftPortion && `
            min-width:30%;
        `}
    }
`;

export const InnerImage = styled.img`
    margin-left: 50%;
    margin-top: 50%;
    width:auto;
    height:auto;
    max-width:${props => props.alt === "Notification  Preferences" ? "15px" : "28px"};
    transform: translate(-50%, -50%);
    @media only screen and (max-width: 850px){
        // width:70%;
        height:60%;
        max-width:${props => props.alt === "Notification  Preferences" ? "28px" : "28px"};
    }
`
export const OuterImage = styled.div`
    background-color: #FF6B00;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    border: 2px solid rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
    @media only screen and (max-width: 850px){
        width: 42px;
        height: 42px;
    }
`
export const MenuDiv = styled.div`
    margin-left:5px;
    & p{
        margin-bottom:0px;
    }
`
export const MenuName = styled.span`
    line-height: 1.2;
    overflow: hidden;
    white-space: nowrap;
    padding-left: 5px;
    color: ${props => props.isActive ? "#FF6B00" : "#000"};
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        & {
            overflow: visible;
            white-space: break-spaces;
            max-width:${props => props.alt === "Notification  Preferences" ? "150px" : "140px"};
        }
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3; 
        overflow: visible;
        text-overflow: ellipsis;
        max-width:${props => props.alt === "Notification  Preferences" ? "150px" : "140px"};
        white-space: break-spaces;
    }
`

export const NavContainer = styled.div`
    cursor: pointer;
    // display: inline-block;
    // width: 173px;
    display: flex;
    position: relative;
    align-items: center;
    // flex: 1 1 0px;
    padding-bottom: 5px;
    margin: 20px 10px 10px 20px;
    width: fit-content;
    //border-bottom: 2px solid #D9D9D9;
    //padding-right: 20px;
    @media only screen and (max-width: 850px){
        flex-direction: column;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        flex-direction: row;
        flex: 1 0 auto;
        padding-right: 10px;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        flex-direction: row;
        flex: 1 0 auto;
    }
}
`

export const JourneyItemsWrapper = styled.div`
    width: 100%;
    height:auto;
    display: flex;
    position: relative;
    align-items: left;
    padding-bottom: 15px;
    flex-direction:row;
    // left: 2vw;
    top:4vh;
    overflow:auto;
    @media only screen and (max-width: 850px){
        width: 100%;
        flex-direction:column;
        left: 0;
        align-items: center;
    }
    @media only screen and (min-width: 601px) and (max-width: 850px) and (orientation : landscape) {
        max-height: 235px;
        overflow-y: auto;
    }
    .hidden-overlay{
        height:unset;
    }
}
`

export const FAQWrapper = styled.div`
    width: 95;
    height::${props => props?.pc ? "auto" : "70vh"};;
    display: flex;
    position: relative;
    align-items: left;
    padding-bottom: 15px;
    flex-direction:column;
    // top:4vh;
    row-gap: 1rem;
    overflow-y: auto;
    overflow-x: clip;

    &::-webkit-scrollbar{
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        background: #fff; 
    }
    &::-webkit-scrollbar-thumb{
        border-radius: 8px;
        background: #C1C1C1; 
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #C1C1C1; 
    }
    @media screen and (max-width: 400px){
        width: 100%;
        height: auto;
    }
    @media screen and (min-width: 401px) and (max-width: 850px){
        width: 100%;
        height: auto;
    }
}
`

export const PhotoGuideWrapper = styled.div`
    display: flex;
    position: relative;
    margin: 2%;
    gap: 4vh 0px;
    flex-wrap: wrap;
`

export const WritingTipsWrapper = styled.div`
    display: flex;
    position: relative;
    margin: 2%;
    gap: 6px 0px;
    flex-wrap: wrap;
    overflow-y: scroll;
    max-height: 58vh;
    padding-right: 2%;
    @media screen and (max-width: 850px){
        width: auto;
    }
    @media screen and (min-width:1200px) and (max-width:1400px){
        height:48vh;
        gap: 20px 0px;
    }
    @media screen and (min-width:1400px) and (max-width:1600px){
       gap: 6px 0px;
    }
    @media screen and (min-width:1600px) and (max-width:1920px){
        height:70vh;
    }
}
`
export const Heading = styled.div`
    display: flex;
    margin: 0 auto 2% auto;
    ${props => props.faq && `
    flex-direction: column;
    justify-content: center;
    align-items: center;
    `}
`

export const TipsWrapper = styled.div`
    position: relative;
    top:1vh;
    width: 100%;
    height: max-content;
    flex-shrink: 0;
    padding: 2vh 0 0 2vh; /* top, right, bottom, left */
    border-radius: 10px;
    background: rgba(247, 246, 245, 1);
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.2);
    overflow: auto;
    display: flex;
    flex-direction: row;
    @media screen and (min-width:1601px) and (max-width:1920px){
        height:max-content;
        margin-bottom:10px;
    }
 
    & img{
        position: relative;
        display: flex;
        width: 45px;
        height: 45px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
    }
 
    &::-webkit-scrollbar{
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        background: #fff;
    }
    &::-webkit-scrollbar-thumb{
        border-radius: 8px;
        background: #C1C1C1;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #C1C1C1;
    }
    @media screen and (max-width: 749px){
        display:flex;
        flex-flow:column;
        height:max-content;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait)
    {
        width: 100%;
        height:max-content;
    }
   
`;

export const WrapperElement = styled.div`
    background-color: rgb(255, 107, 0);
    border-radius: 50%;
    width: 50px;
    height: 50px;
    border: 2px solid rgb(255, 255, 255);
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 3px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    & img{
        width: 22px;
        height:22px;
    }
    @media screen and (max-width: 749px){
        width: 50px;
        height: 50px;
        margin:0 auto;
        margin-bottom:1rem;
        & img{
            width:22px;
            height:22px;
        }
    }
    @media only screen and (min-width:1200px) and (max-width:1400px){}
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait)
    {
        width: 50px;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape)
    {
        width: 50px;
    }
`;
export const ListWrapper = styled.div`
    position: relative;
    left:2vh; 
    width: 78%;
    overflow:auto;
    & ul{
        list-style: none;
        li {
            color: #111;
            font-family: Lato;
            font-size: 15px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;
            letter-spacing: 0.16px;
            :before {
                content: "•"; 
                color: #FF6B00;
                padding-right:20px;                ;
                display: inline-block; 
                width: 10px;
                height:10px;
                margin-left: -20px;
            }
        }
    }
    @media screen and (max-width: 480px){
        width: 100%;
        left:0;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        width: 86%;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        width: 86%;
    }
`

export const TipsTitle = styled.div`
    color: #111;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
    margin-bottom:0.7rem;

    @media screen and (max-width: 749px){
        text-align:Center;
        margin-bottom:1rem;
        font-weight:700;
    }
`;

export const MenuContainer = styled.div`
    display: ${props => props.mobile == true || props.gift ? "" : "flex"};
    flex-direction: ${props => props.news ? "column" : ""};
    width: 100%;
    height:-webkit-fill-available;
    overflow-y:auto;
    // background: #F3F3F3;
    //background-image: linear-gradient(to bottom, rgba(1,1,1,0), rgba(243, 243, 243, 1));
    ${props => props.gift && `
        background-image: linear-gradient(to bottom, rgba(1,1,1,0), rgba(243, 243, 243, 1));
    `}
    @media screen and (max-width: 850px){
        width: 100%;
        height:100%;
    ${props => props.news && `
       background:url(${StationsModalBg}) no-repeat 0 0;
        background-repeat: no-repeat;
        @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
        {
            width:100%; 
        }
    `}
    }
    
    &::-webkit-scrollbar{
        width: 0px;
    }
    &::-webkit-scrollbar-track {
        background: #fff; 
    }
    &::-webkit-scrollbar-thumb{
        border-radius: 8px;
        background: #C1C1C1; 
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #C1C1C1; 
    }
    {
    -ms-overflow-style: ${(props) => (props.news ? "thin" : "none")};
    scrollbar-width: ${(props) => (props.news ? "thin" : "none")};
  }

`;


export const NotificationDiv = styled.div`
display:flex;
padding:10px;
gap: 10px;
border-radius:4px;
border: 1px solid #FF6B00;
background-color: rgba(246, 236, 235, 1);
justify-content: center;
align-items: center;
width: 70%;
height:40px;
//margin: auto;
margin-top: 5px;
font-size:12px;
position:fixed;
left: 10%;
@media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
{
    margin-top: 2%;
    left: 2%;
    width: 95%;
}
@media only screen and (max-device-width: 750px) {
    padding: 10px 10px 10px;
    height: 80px;
    justify-content: flex-start;
    align-items: flex-start;
    left: 2%;
    width: 95%;
    padding-bottom: 80px;
    margin-top: 15px;
    border-radius:8px;
}
@media only screen and  (min-device-width: 360px) and (max-device-width: 400px) {
    // height: 98px;
}
& p{
 margin-bottom:0;
 flex-grow:1;
 font-family:inherit;
 @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        width: 60%;
    }
}
& button {
 background-color: transparent;
 color: rgba(199, 0, 0, 1);
 border: none;
 cursor: pointer;
 text-decoration:underline;
 font-size:14px;
 font-weight:700;
 @media only screen and  (min-device-width: 360px) and (max-device-width: 400px) {
   font-size:12px;
}
}
#close{
padding-left: 1.5%;
border-left: 1px solid rgb(153, 153, 153);
@media only screen and  (min-device-width: 360px) and (max-device-width: 450px) {
    height:60px;
 }
 @media only screen and  (min-device-width: 1200px) and (max-device-width: 1920px) {
    height:22px;
    padding-left: 1%;
 }
}

#yesButton {
order: 0; 
@media only screen and (max-width: 750px) {
    position: absolute;
    left: 10%;
    bottom: 7px;
}
@media only screen and  (min-device-width: 360px) and (max-device-width: 450px) {
    left: 11%;
 }
}  
`;

export const NotificationDivSuccess = styled.div`
display:flex;
padding:6px 10px;
border-radius:4px;
border: 1px solid rgba(56, 150, 119, 1);
background-color: rgba(255, 255, 255, 1);
justify-content: space-between;
align-items: center;
width: 100%;
height:max-content;
margin:1% auto 2%;
font-size:14px;
position:relative;
animation: fadeInOut 10s ease-in-out forwards;
@keyframes fadeInOut {
    0% {
      opacity: 0;
    }
    10% {
      opacity: 1;
    }
    90% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
@media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
{
    margin-top: 3%;
}
@media only screen and (max-device-width: 750px) {
    padding: 12px 10px 10px;
    height: 80px;
    justify-content: flex-start;
    align-items: flex-start;
}
@media only screen and  (min-device-width: 360px) and (max-device-width: 400px) {
    // height: 98px;
}

.notification-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width:100%;
    @media only screen and (max-width:750px){
        flex-direction: column;
        align-items: flex-start;
    }
    @media only screen and (min-width:750px) and (max-width:1199px){
        flex-direction: column;
        align-items: flex-start;
    }
}

& img{
    margin-right:10px;
}
& span{
    margin-right:5px;
}
& p{
 margin-bottom:0;
 flex-grow:1;
 font-family:inherit;
 @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        width: 100%;
    }
}
.warning_msg{
    font-size:14px;
}
& button {
 background-color: transparent;
 color: rgba(199, 0, 0, 1);
 border: none;
 cursor: pointer;
 text-decoration:underline;
 font-size:14px;
 font-weight:700;
 @media only screen and  (min-device-width: 360px) and (max-device-width: 400px) {
   font-size:12px;
}
}
#close{
padding-left: 1.5%;
border-left: 1px solid rgb(153, 153, 153);
height: 60px;
@media only screen and  (min-device-width: 360px) and (max-device-width: 400px) {
    height:60px;
 }
 @media only screen and  (min-device-width: 1200px) and (max-device-width: 1920px) {
    height:22px;
    padding-left: 1%;
 }
}

#yesButton {
order: 0; 
@media only screen and (max-width: 750px) {
    position: absolute;
    left: 10%;
    bottom: 7px;
}
@media only screen and  (min-device-width: 360px) and (max-device-width: 450px) {
    left: 11%;
 }
}  
`;
export const NotificationDivFailure = styled.div`
display:flex;
padding:10px;
border-radius:4px;
border: 1px solid #FF6B00;
background-color: rgba(246, 236, 235, 1);
justify-content: space-between;
align-items: center;
width: 100%;
height:max-content;
margin:1% auto 2%;
font-size:14px;
position:relative;
animation: fadeInOut 20s ease-in-out forwards;
@keyframes fadeInOut {
    0% {
      opacity: 0;
    }
    10% {
      opacity: 1;
    }
    90% {
      opacity: 1;
    }
    100% {
      opacity: 1;
    }
  }

@media only screen and (max-device-width: 750px) {
    padding: 12px 10px 10px;
    height: max-content;
    justify-content: flex-start;
    align-items: flex-start;
}


.notification-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    width:100%;
    @media only screen and (max-width:750px){
        flex-direction: column;
        align-items: flex-start;
    }
    @media only screen and (min-width:750px) and (max-width:1600px){
        flex-direction: column;
        align-items: flex-start;
        padding-left:5px;
    }
}

& img{
    margin-right:10px;
}
& span{
    margin-right:5px;
}
& p{
 margin-bottom:0;
 flex-grow:1;
 font-family:inherit;
 @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        width: 100%;
    }
}
.warning_msg{
    font-size:14px; 
    line-height:18px;
    margin-right:10px;
}
& button {
 background-color: transparent;
 color: rgba(199, 0, 0, 1);
 border: none;
 cursor: pointer;
 text-decoration:underline;
 font-size:14px;
 font-weight:700;
 @media only screen and  (min-device-width: 360px) and (max-device-width: 400px) {
   font-size:12px;
}
}
#close{
padding-left: 1.5%;
border-left: 1px solid rgb(153, 153, 153);
height: 60px;
@media only screen and  (min-device-width: 360px) and (max-device-width: 400px) {
    height:60px;
 }
 @media only screen and (max-width:750px){
    height:80px;
 }
 @media only screen and  (min-device-width: 1200px) and (max-device-width: 1920px) {
    height:22px;
    padding-left: 1%;
 }
}

#yesButton {
order: 0; 
@media only screen and (max-width: 750px) {
    position: absolute;
    left: 10%;
    bottom: 7px;
}
@media only screen and  (min-device-width: 360px) and (max-device-width: 450px) {
    left: 11%;
 }
}  
`;


export const RightMenuContainer = styled.div`
    width:27%;
    height:90vh;
    align-items: center;
    text-align: center;
    display: flex;
    flex-direction: column;
    //background-image: linear-gradient(to bottom, rgba(255, 255, 255,0), rgba(255, 255, 255, 1) 30%);     
    @media screen and (min-width: 1200px) and (max-width: 1920px){
    background:${props => props?.account ? `url(${StationsModalBg}) no-repeat 0 0` : `url(${StationsModalBg}) no-repeat 0 0 #ffffff`};

        padding-bottom: 1%;
        overflow-y:auto;
    &::-webkit-scrollbar{
        width: 0px;
    }
    &::-webkit-scrollbar-track {
        background: #fff; 
    }
    &::-webkit-scrollbar-thumb{
        border-radius: 8px;
        background: #C1C1C1; 
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #C1C1C1; 
    }
    {
      -ms-overflow-style: none;
      scrollbar-width: thin;
    }
 
    }
    @media screen and (max-width: 600px){
        width: auto;
        height: unset;
    }
    @media screen and (min-width: 601px) and (max-width: 850px){
        margin-bottom:10%;
        margin-top:3%;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        width:100%;
        flex-direction: ${props => props?.account ? "row" : "column"};
    }
    
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        width:30%;
        overflow-y:auto;
    }
    @media screen and (min-width: 1600px){
        padding-bottom:0;
    }
`;

export const ActiveSponsorChildWrapper = styled.div`
    width: 65%;
    padding: 3% 0% 10% 0.5%;
    // margin: 22px  29px 0px 29px;
    //margin: 0px 29px 0px 29px;
    @media screen and (max-width: 850px){
        width: 90%;
        padding: 0 5% ;
        margin: 0px 5%;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        width:100%;
        margin:0 auto;
        padding: 3%;
    }
    .slick-prev {
        left: -7%;
    }
    .slick-next {
        right: 7%;
    }
    & :not(.slick-current)  > div > div  {box-shadow:none}
`;
export const AccountWrapper = styled.div`
    position:relative;
    display:flex;
    width:100%;
    // padding:0 2%;
    height:calc(100vh-60px);
    @media screen and (max-width: 850px){
    &{
        background:url(${StationsModalBg}) no-repeat 0 0;
        background-repeat: no-repeat;
        background-size:100%; 
        height: auto;
        flex-direction:column;
    }
    }
`;

export const SponsorChildImage = styled.div`
    & img{
        width: 41px;
        height: 41px;
        border-radius: 50%;
    }
`

export const ArrowIcon = styled.img`
    width: ${props => props?.account ? "10px" : "5px"};
    height: ${props => props?.account ? "15px" : "10px"};
    margin-left: auto;
    margin-right: 13px;
    cursor: pointer;
`;

export const ActiveIcon = styled.img`
    width: 10px;
    height: 10px;
    margin-left: 10px;
    margin-top: 4px;
`;

export const SliderArrow = styled.img`
    width: 14.972px;
    height: 8.167px;
`
export const PaymentInfoWrapper = styled.div`
    width:90%;
    position:relative;
    height:9vh;
    align-items: center;
    display: flex;
    left: 2.5vw;
    & span{
        color: #111;
        font-family: Lato;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 135%;
        letter-spacing: 0.16px;
    }
    & button{
        position: absolute;;
        width: 1.7vw;
        height: 3vh;
        right: 1.8vw;
        background: url(${RedirectIcon}) 0 0 no-repeat;
    }
    @media screen and (max-width: 850px){
        width:100%;
        & button{
            width: 3vh;
            right:10%;
        }
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        & button{
            width: 3vh;
            right:7.5%;
        }
    }

    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        & button{
            width: 3vh;
            right:10px;
        }
    }
`;

export const TaxStatWrapper = styled.div`
    width:90%;
    position:relative;
    height:9vh;
    align-items: center;
    display: flex;
    left: 2.5vw;
    & span{
        color: #111;
        font-family: Lato;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 135%;
        letter-spacing: 0.16px;
    }
    & button{
        position: absolute;;
        width: 1.7vw;
        height: 3vh;
        right: 1.5vw;
        top:4vh;
        background-size: contain;
        background: url(${props => (props?.redirection ? RedirectIcon : props?.children[1]?.props?.open ? (arrowup) : (arrowdown))})  0 0;
        background-repeat: no-repeat;
    }
    @media screen and (max-width: 850px){
        width: 100%;
        & button{
            width: 10%;
        } 
    }
`;

export const QuestionsWrapper = styled.div`
    width:94%;
    position:relative;
    height: auto;
    align-items: center;
    display: flex;
    left: ${props => props?.pc ? "" : "2.5vw"};
    flex-shrink: 0;
    padding: 2vh;
    border-radius: 10px;
    border: 1px solid #D8D8D8;
    background: #F7F6F5;
    min-height: 55px;
    align-items: center;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
    & span{
        color: #000;
        font-family: Lato;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        width: 95%;
    }
    & button {
        position: absolute;
        width: 22px;
        height: 22px;
        right: 1.5vw;
        top: 2vh;
        background: url(${PCCircledArrowUp}) 0 0;
        background-size: contain;
        background-repeat: no-repeat;
        transform: ${props => (props?.children[1]?.props?.open ? "rotate(180deg)" : "rotate(0deg)")};
        transition: transform 0.3s ease;
      }
      
    @media screen and (max-width: 750px){
        width: 97%;
        & button{
            width: 26px;
            height: 25px;
            right: 3vw;
        } 
    }
    @media screen and (min-width: 600px) and (max-width: 850px){
        width: 97%;
        & button{
            width: 2.5vw;
        } 
    }
`;

export const AnswersWrapper = styled.div`
    position:relative;
    padding: 2vh 4vw 1vh 0.5vh;
    color: #474747;
    font-family: Lato;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0.14px;
    @media screen and (max-width: 750px){
        font-size: 16px;
    }
`


export const StatementsWrapper = styled.div`
  border-top: none;
  opacity: ${props => (props.open ? "1" : "0")};
  max-height: ${props => (props.open ? "100%" : "0")};
  overflow: hidden;
  padding: ${props => (props.open ? "15px" : "0 15px")};
  transition: all 0.3s;

  p {
    position: relative;
    display: flex;
    left:3vh;
    top:-1vh;
    width: 80%;
    flex-direction: column;
    flex-shrink: 0;
    color: #000;
    font-family: Lato-bold;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 135%;
    letter-spacing: 0.14px;
  }
  @media screen and (max-width: 600px){
    & p{
        left:0;
        width: 95%;
    } 
}
  @media screen and (max-width: 850px){
    & p{
        left:1vh;
        width: 80%;
        } 
    }
`;

export const HistoryWrapper = styled.div`
    width:100%;
    position:relative;
    height:9vh;
    align-items: center;
    display: flex;
    left: 2.5vw;
    & span{
        color: #111;
        font-family: Lato;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 135%;
        letter-spacing: 0.16px;
    }
    & button{
        position: absolute;;
        width: 1.7vw;
        height: 2vh;
        right: 2.5vw;
        top:4vh;
        background: url(${props => (props?.children[1]?.props?.open ? (arrowup) : (arrowdown))})  0 0;
        background-size: contain;
        background-repeat: no-repeat;
    }
`;

export const GiftImage = styled.img`
    width: 20px;
    height: 20px;
`

export const SendAGiftWrapper = styled.div`
    display: flex;
    position: absolute;
    left: 81.5%;
    top: 23px;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    cursor: pointer;
`
export const BibleWrapper = styled.div`
    height:60vh;
    display: flex;
    position: relative;
    align-items: left;
    margin: 2% 0%;
    row-gap:4vh;
    column-gap:0;
    overflow-y: auto;
    flex-wrap: wrap;
    overflow-y:auto;
    border-top:1px solid rgba(0, 0, 0, 0.1);
    @media screen and (max-width: 750px){
        width: auto;
        height: 72vh;
    }
    @media screen and (min-width:1200px) and (max-width:1400px){
        height:50vh;
    }
    @media screen and (min-width:1601px) and (max-width:1920px){
        height:68vh;
        row-gap:2vh;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait)
    {
        height:72vh;
    }
}
`
export const ListWrapperContent = styled.div`
   
    & ul{
        list-style: none;
        padding-left:0px;
        li {
            color: #111;
            font-family: Lato;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;
            letter-spacing: 0.16px;
            :before {
                content: "•";
                color: #FF6B00;
                padding-right:20px;
                display: inline-block;
                width: 10px;
                height:10px;
                margin-left: 0px;
            }
        }
    }
   
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait)
    {
        width: 100%;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape)
    {
        width: 78%;
    }
    @media screen and (min-width: 1600px){
        overflow:none;
    }
`

